// Quick Lookups (MEDirect Quick Lookup prompt pack v0.1) stay dark until Sue and
// Ross approve the pack. Off unless VITE_QUICK_LOOKUPS_ENABLED is "true"; read
// at call time so tests can stub it.
export const isQuickLookupsEnabled = (): boolean =>
  import.meta.env.VITE_QUICK_LOOKUPS_ENABLED === "true";
